/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupJobType } from '../models/BackupJobType';
import { BackupVault } from '../models/BackupVault';
import { JobExecutionDetails } from '../models/JobExecutionDetails';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails';
import { JobStep } from '../models/JobStep';
import { ResourceDetails } from '../models/ResourceDetails';

export class BackupJob {
  'jobExecutionDetails': JobExecutionDetails;
  'resourceDetails'?: ResourceDetails | null;
  'snapshotDetails'?: JobSnapshotDetails | null;
  'backupType': BackupJobType;
  'vault'?: BackupVault | null;
  /**
  * The ID of the backup policy
  */
  'backupPolicyId'?: string | null;
  /**
  * The IDs of the cloud snapshots which the backup job used - relevant when backing up from a cloud snapshot
  */
  'cloudSnapshotIds'?: Array<string>;
  /**
  * Job steps. Only populated for job types that have steps defined.
  */
  'steps'?: Array<JobStep> | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobExecutionDetails",
      "baseName": "jobExecutionDetails",
      "type": "JobExecutionDetails",
      "format": ""
    },
    {
      "name": "resourceDetails",
      "baseName": "resourceDetails",
      "type": "ResourceDetails",
      "format": ""
    },
    {
      "name": "snapshotDetails",
      "baseName": "snapshotDetails",
      "type": "JobSnapshotDetails",
      "format": ""
    },
    {
      "name": "backupType",
      "baseName": "backupType",
      "type": "BackupJobType",
      "format": ""
    },
    {
      "name": "vault",
      "baseName": "vault",
      "type": "BackupVault",
      "format": ""
    },
    {
      "name": "backupPolicyId",
      "baseName": "backupPolicyId",
      "type": "string",
      "format": ""
    },
    {
      "name": "cloudSnapshotIds",
      "baseName": "cloudSnapshotIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "steps",
      "baseName": "steps",
      "type": "Array<JobStep>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupJob.attributeTypeMap;
  }

  public constructor() {
  }
}



